import React from 'react'
import AngleBracket from './angleBracket'

const AngleBracketButton = ({
  text,
  link,
  style,
  caretStyle,
  textStyle,
  hasShadow = true,
  hasCaret = true,
  caretPosition = 'right',
  caretDirection = 'right',
  newTab = false,
  ...rest
}) => (
  <div {...rest} className={'unselectable'}>
    {link ? (
      <a
        href={link}
        style={{
          ...buttonStyle,
          justifyContent: hasCaret ? ( caretPosition === 'right' ? 'space-between' : 'flex-start' ) : 'center',
          textAlign: 'left',
          ...style,
        }}
        target={newTab ? '_blank' : '_self' }
        className={hasShadow ? 'card' : ''}
      >
        {hasCaret &&
          caretPosition === 'left' && (
            <AngleBracket
              style={{
                width: 6.3,
                height: 12.6,
                marginRight: '1em',
                ...angleCaretStyle(caretDirection),
                ...caretStyle,
              }}
            />
          )}
        <div
          style={{ ...defaultTextStyle, ...textStyle }}
          dangerouslySetInnerHTML={{ __html: text }}
        />
        {hasCaret &&
          caretPosition === 'right' && (
            <AngleBracket
              style={{
                width: 6.3,
                height: 12.6,
                marginLeft: '1em',
                ...angleCaretStyle(caretDirection),
                ...caretStyle,
              }}
            />
          )}
      </a>
    ) : (
      <div
        style={{
          ...buttonStyle,
          cursor: 'pointer',
          justifyContent: hasCaret ? ( caretPosition === 'right' ? 'space-between' : 'flex-start' ) : 'center',
          ...style,
        }}
        className={hasShadow ? 'card' : ''}
      >
        {hasCaret &&
          caretPosition === 'left' && (
            <AngleBracket
              style={{
                width: 6.3,
                height: 12.6,
                marginRight: '1em',
                ...angleCaretStyle(caretDirection),
                ...caretStyle,
              }}
            />
          )}
        <div
          style={{ ...defaultTextStyle, ...textStyle }}
          dangerouslySetInnerHTML={{ __html: text }}
        />
        {hasCaret &&
          caretPosition === 'right' && (
            <AngleBracket
              style={{
                width: 6.3,
                height: 12.6,
                marginLeft: '1em',
                ...angleCaretStyle(caretDirection),
                ...caretStyle,
              }}
            />
          )}
      </div>
    )}
  </div>
)

export default AngleBracketButton

const buttonStyle = {
  background: 'white',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  padding: '1rem 1.5rem',
}

const defaultTextStyle = {
  fontWeight: '700',
  fontSize: '16px',
}

const angleCaretStyle = direction =>
  ({
    right: {},
    left: {
      transform: 'scaleX(-1)',
      filter: 'FlipH',
    },
    down: {
      transform: 'rotate(90deg)',
    },
    up: {
      transform: 'rotate(-90deg)',
    },
  }[direction])



// WEBPACK FOOTER //
// ./src/components/shared/angleBracketButton.js